module.exports = __webpack_public_path__ + "static/media/cross-device-mockup-16x10-desktop@1x.86a6ce0d.png";